import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ContentBlock } from 'components/ContentBlock'
import ToggledContentWrapper from 'components/ToggledContentWrapper'

class StatisticsData extends Component {
	render({ children, toggling, label } = this.props) {
		return(toggling ?
			<ToggledContentWrapper label={label} attachToNextBlock>
				{children}
			</ToggledContentWrapper>
			: <ContentBlock>{children}</ContentBlock>
		)
	}
}

StatisticsData.propTypes = {
	toggling: PropTypes.bool,
	label: PropTypes.string
}
StatisticsData.defaultProps = {
	label: 'Erweitern'
}

export default StatisticsData
